import mcrypt from 'fdoering-mcrypt';
import {Base64} from 'js-base64';

const _cipher = 'rijndael-128';
const _mode = 'ecb';

export const encrypt = function encrypt(data, secret) {
	if (typeof data == 'string' || data instanceof String) {
		//
	} else {
		data = JSON.stringify(data);
	}

	var result = mcrypt.Encrypt(data, null, secret, _cipher, _mode);
	result = Base64.btoa(result);
	return result;
};

export const decrypt = function decrypt(data, secret) {
	data = Base64.atob(data);
	var origtext = mcrypt.Decrypt(data, null, secret, _cipher, _mode);

	return JSON.parse(JSON.parse(JSON.stringify(origtext).replace(/\\u0000/g, '')));
};
